import { Box, useStyleConfig } from "@chakra-ui/react";
import { PropsWithChildren }  from 'react';

function PanelContent(props: PropsWithChildren<any>) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("PanelContent", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}

export default PanelContent;
